import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";

import AccountCircle from '@mui/icons-material/AccountCircle';

import {authLogout} from "../../redux/auth/authActions";
import {persistSetEditing, persistSetThemeLight} from "../../redux/persist/persistActions";

import {
	styled,
	Paper,
	Typography,
	Divider,
	Button,
	Switch,
	ClickAwayListener,
	Grid,
	Avatar,
	InputLabel,
	Select,
	MenuItem
} from '@mui/material';

const PREFIX = 'ProfileMenu';

const classes = {
	root: `${PREFIX}-root`,
	button: `${PREFIX}-button`,
	linearProgress: `${PREFIX}-linearProgress`
};

const StyledPaper = styled(Paper)((
	{
		theme
	}
) => ({
	[`&.${classes.root}`]: {
		width: '100%',
		height: '100%',
		overflow: 'hidden'
	},
	[`& .${classes.button}`]: {
		width: '100%',
		marginTop: '5px',
	},
	[`& .${classes.linearProgress}`]: {
		height: '1px'
	}
}));

export default function ProfileMenu({ handleOnClose }) {
	const dispatch = useDispatch();
	const { t, i18n } = useTranslation();

	// App State
	const auth = useSelector(state => state.auth);
	const version = useSelector(state => state.config.data.version);
	const isThemeLight = useSelector(state => state.persist.themeLight);
	const isEditing = useSelector(state => state.persist.isEditing);

  	const isDraggable = version !== undefined ? (version >= 2) : false;

	const handleLogout = () => {
		dispatch(authLogout());
	};

	const changeLanguage = lng => {
		i18n.changeLanguage(lng.target.value);
		//dispatch
		// persist translation
	};

	const handleToggleTheme = () => {
		dispatch(persistSetThemeLight(!isThemeLight));
	}

	const handleToggleDashboard = () => {
		dispatch(persistSetEditing(!isEditing));
	}

	return (
		<ClickAwayListener onClickAway={handleOnClose}>
			<StyledPaper className={classes.root}>
				<div style={{ display: 'flex', padding: '0px 16px 16px 16px' }}>
					{auth.avatar && (
						<Avatar src={auth.avatar} />
					)}
					{!auth.avatar && (
						<AccountCircle color="primary" style={{ fontSize: '64px' }} />
					)}
					<div style={{ padding: '0px 8px 0px 8px', overflow: 'hidden' }}>
						<Typography
							style={{ fontWeight: 'bold' }}
							variant="body2"
							gutterBottom
						>
							Welcome
						</Typography>
						<Typography
							style={{ fontWeight: 'bold' }}
							variant="caption"
							gutterBottom
						>
							{auth.username}
						</Typography>
					</div>
				</div>
				<Divider />
				<Typography component="div" style={{marginTop: '20px', marginBottom:'20px'}}>
					<Grid component="label" container alignItems="center" spacing={1}>
						<Grid item xs={12} style={{textAlign: "center"}}>
							<div>
								<Typography variant="overline" display="inline" style={{fontStyle: 'italic'}}>
									Lightside
								</Typography>
								<Switch color="primary" display="inline-block" onChange={handleToggleTheme} checked={!isThemeLight}/>
								<Typography variant="overline" display="inline" style={{fontStyle: 'italic'}}>
									Darkside
								</Typography>
							</div>
						</Grid>
					</Grid>
				</Typography>
				<Divider />
				{isDraggable &&
					<React.Fragment>
						<Typography component="div" style={{marginTop: '20px', marginBottom: '20px'}}>
							<Grid component="label" container alignItems="center" spacing={1}>
								<Grid item xs={12} style={{textAlign: "center"}}>
									<div>
										<Typography variant="overline" display="inline" style={{fontStyle: 'italic'}}>
											Set Dashboard
										</Typography>
										<Switch color="primary" display="inline-block" onChange={handleToggleDashboard} checked={isEditing}/>
										<Typography variant="overline" display="inline" style={{fontStyle: 'italic'}}>
											Edit Dashboard
										</Typography>
									</div>
								</Grid>
							</Grid>
						</Typography>
						<Divider />
					</React.Fragment>
				}
				<Typography component="div" style={{marginTop: '20px', marginBottom:'20px'}}>
					<Grid component="label" container alignItems="center" spacing={1}>
						<Grid item xs={6} style={{textAlign: 'right'}}>
							<InputLabel id="language-select-helper-label">Language</InputLabel>
						</Grid>
						<Grid item xs={6}>
							<Select
								MenuProps={{style:{zIndex:100000}}}
								labelId="select-helper-label"
								id="select-helper"
								value={i18n.language}
								onChange={changeLanguage}
								variant={"standard"}
							>
								<MenuItem value={'en-GB'}>EN-GB</MenuItem>
								<MenuItem value={'en-US'}>EN-US</MenuItem>
								<MenuItem value={'de'}>DE</MenuItem>
								<MenuItem value={'fr'}>FR</MenuItem>
								<MenuItem value={'es'}>ES</MenuItem>
							</Select>
						</Grid>
					</Grid>
				</Typography>

				<Divider />

				<Button color={isThemeLight ? "primary" : "secondary"} className={classes.button} onClick={handleLogout}>
					LOGOUT
				</Button>
			</StyledPaper>
		</ClickAwayListener>
	);
}
